/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../core/utils"
import React from "react"
import { Form, FormGroup } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"
import NumberFormat from "react-number-format"

const regex = /[AaYyMmDdJj]/g

export default function (props) {
  const { format, label, hidden, name, disabled, placeholder, children } = props

  if (typeof String.prototype.replaceAll === "undefined") {
    // eslint-disable-next-line no-extend-native
    String.prototype.replaceAll = function (match, replace) {
      return this.replace(new RegExp(match, "g"), () => replace)
    }
  }

  return hidden ? null : (
    <FinalFormField name={name} component="input" type="text" className="form-control">
      {({ input, meta }) => {
        const metaError = (meta.error || meta.submitError) && meta.touched

        return (
          <FormGroup>
            <div className="d-flex">
              {label && <Form.Label>{label}</Form.Label>}
              {children}
            </div>
            <NumberFormat
              id={name}
              {...input}
              format={format.replaceAll(regex, "#")}
              className="form-control"
              placeholder={placeholder ? placeholder : loc(format)}
              mask={"_"}
              disabled={disabled}
              autoComplete="off"
            />
            {metaError && <p className="required-message">{meta.error || meta.submitError}</p>}
          </FormGroup>
        )
      }}
    </FinalFormField>
  )
}
